export default function HomeInActive({ width = 22, height = 23, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 22 23"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M9.52051 1.30127C10.3937 0.633537 11.6063 0.633538 12.4795 1.30127L20.2441 7.23877C20.8466 7.69954 21.2002 8.41487 21.2002 9.17334V20.2563C21.2002 21.0295 20.573 21.6567 19.7998 21.6567H16.2803C15.5071 21.6567 14.8799 21.0295 14.8799 20.2563V15.3452C14.8797 14.2962 14.0295 13.4461 12.9805 13.4458H9.01953C7.9705 13.4461 7.12027 14.2962 7.12012 15.3452V20.2563C7.12012 21.0295 6.49293 21.6567 5.71973 21.6567H2.2002C1.427 21.6567 0.799805 21.0295 0.799805 20.2563V9.17334C0.799805 8.41487 1.1534 7.69954 1.75586 7.23877L9.52051 1.30127Z"
                stroke="#959595"
                strokeWidth="1.6"
            />
        </svg>
    );
}
